/**
 * inViewport jQuery plugin by Roko C.B.
 * http://stackoverflow.com/a/26831113/383904
 * Returns a callback function with an argument holding
 * the current amount of px an element is visible in viewport
 * (The min returned value is 0 (element outside of viewport)
 */
;(function($, win) {
    $.fn.inViewport = function(cb) {
        return this.each(function(i,el){
            function visPx(){
                var elH = $(el).outerHeight(),
                    H = $(win).height(),
                    r = el.getBoundingClientRect(), t=r.top, b=r.bottom;
                return cb.call(el, Math.max(0, t>0? Math.min(elH, H-t) : Math.min(b, H)));  
            } visPx();
            $(win).on("resize scroll", visPx);
        });
    };
}(jQuery, window));





window.addEventListener('DOMContentLoaded', function () {
    let zoomEnabled = false;

    const productImages = document.querySelectorAll('.product-slider-for .zoomable-image');

    productImages.forEach((image) => {
        image.addEventListener('mousemove', function (e) {
            if (!zoomEnabled) return;

            let width = this.offsetWidth;
            let height = this.offsetHeight;
            let offsetX = e.offsetX;
            let offsetY = e.offsetY;

            let scaleX = 1.5;
            let originX = (offsetX / width) * 100;
            let originY = (offsetY / height) * 100;

            this.style.transformOrigin = `${originX}% ${originY}%`;
            this.style.transform = `scale(${scaleX})`;
        });

        image.addEventListener('mouseout', function () {
            this.style.transform = 'scale(1)';
        });
    });

    document.querySelectorAll('.js-zoom-in').forEach((button) => {
        button.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            zoomEnabled = true;
            button.style.display = 'none';
            button.nextElementSibling.style.display = 'inline'; // Show the zoom-out button
        });
    });

    document.querySelectorAll('.js-zoom-out').forEach((button) => {
        button.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            zoomEnabled = false;
            button.style.display = 'none';
            button.previousElementSibling.style.display = 'inline'; // Show the zoom-in button
        });
    });
});



/* Toggle between adding and removing the "responsive" class to topnav when the user clicks on the icon */
function myFunction() {
    var x = document.getElementById("myTopnav");
    if (x.className === "topnav") {
        x.className += " responsive";
    } else {
        x.className = "topnav";
    }
}

function openFooterLinks() {
    $(".footer-links ul").slideDown();
    $('#footer-dropdown').attr("style", "display: none !important");
    $('#footer-dropup').attr("style", "display: inline !important");

}

function closeFooterLinks() {
    $(".footer-links ul").slideUp();
    $('#footer-dropdown').attr("style", "display: inline !important");
    $('#footer-dropup').attr("style", "display: none !important");
}

document.getElementById('headerSearchText').onkeyup = function (event) {
    var e = event || Window.event;
    if (e.keyCode == 13) {
        siteSearch(false)
    }
}

function siteSearch(isSearchPage) {
    var searchText = "keyword=" + (isSearchPage ? document.getElementById("searchText").value : document.getElementById("headerSearchText").value);
    var searchMode = "&searchMode=anyword";
    window.location.href = "/search?" + searchText + searchMode;
}

function mobileSiteSearch(isSearchPage) {
    var searchText = "keyword=" + document.getElementById("mobileSearchText").value;
    var searchMode = "&searchMode=anyword";
    window.location.href = "/search?" + searchText + searchMode;
}

 //// Shows the header search bar (hides the phone number)
 //document.getElementById("search-icon").onclick = function(event){
 //  $('#headerSearchText').attr("style", "display: block !important");
 //  $('#header-phone, #header-phone-icon).attr("style", "display: none !important");
 //}

 //// Show the phone number (hides the search box)
 //document.getElementById("header-phone-icon").onclick = function(event){
 //  $('#header-phone, #header-phone-icon').attr("style", "display: block !important");
 //  $('#headerSearchText').attr("style", "display: none !important");
 //}


 var mobileScreen = window.matchMedia("(max-width: 991px)");
 var desktopScreen = window.matchMedia("(min-width: 992px)");
 
 desktopScreen.addListener(function (changed) {
     if (changed.matches) {
         console.log("Changed to desktop screen size.");
     } else {
         console.log("Changed to non-desktop (smaller) screen size.");
     }
 });
 
 $(document).ready(function () {
     var isOpen = false;
 
     if (mobileScreen.matches) {
         $('#link-search-icon').hide();
         $('#close-icon').hide();
         $('#search-icon').show();
 
         $('#search-icon').click(function () {
             if (!isOpen) {
                 $('#search-icon').hide();
                 $('#close-icon').show();
                 isOpen = true;
             }
         });
 
         $('#close-icon').click(function () {
             $('#searchDropdown').hide();
             $('#close-icon').hide();
             $('#search-icon').show();
             isOpen = false;
         });
 
         $(document).on('click', function (event) {
             if (isOpen && !$(event.target).closest('#searchDropdown').length) {
                 $('#searchDropdown').hide();
                 $('#close-icon').hide();
                 $('#search-icon').show();
                 isOpen = false;
             }
         });
     }
 
     if (desktopScreen.matches) {
         $('#link-search-icon').show();
         $('#close-icon').hide();
         $('#search-icon').hide();
 
         // Show the search box and the close icon when the search icon is clicked
         $('#link-search-icon').click(function () {
             if (!isOpen) {
                 $('.js-search-wrapper').addClass('test');
                 $('.js-contact-wrapper').fadeIn(250).addClass('test');
                 $('#link-search-icon').hide();
                 $('#search-icon').show();
                 $('#close-icon').show();
                 isOpen = true;
             }
         });
 
         // Explicitly define the action when the close icon is clicked
         $('#close-icon').click(function () {
             $('.js-search-wrapper').removeClass('test');
             $('.js-contact-wrapper').fadeOut(250, function () {
                 $(this).removeClass('test');
                 $('.js-contact-wrapper').fadeIn(250).removeClass('test');
             });
             $('#close-icon').hide();
             $('#link-search-icon').show();
             $('#search-icon').hide();
             isOpen = false;
         });
 
         // Hide the search box, the close icon, and show the search icon when anything outside the search wrapper is clicked
         $(document).on('click', function (event) {
             if (isOpen && !$(event.target).closest('.js-search-wrapper').length) {
                 $('.js-search-wrapper').removeClass('test');
                 $('.js-contact-wrapper').fadeOut(250, function () {
                     $(this).removeClass('test');
                     $('.js-contact-wrapper').fadeIn(250).removeClass('test');
                 });
                 $('#close-icon').hide();
                 $('#link-search-icon').show();
                 $('#search-icon').hide();
                 isOpen = false;
             }
         });
     }
 
     // Prevent the document click event from being triggered when the search box or icons are clicked
     $('#link-search-icon, #close-icon, .js-search-wrapper').click(function (event) {
         event.stopPropagation();
     });
});





$('.mobile-menu-icon').click(function () {
    $('.nav').toggleClass('nav-open');
});

$('.nav-list-item-toggle').click(function () {
    $(this).toggleClass('active');
    $(this).next('ul').toggleClass('nav-item-open');
});

var width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
if (width >= 768) {
    $('.home-slider').slick({
        arrows: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        infinite: true,
        centerMode: true,
        focusOnSelect: false,
        responsive: [
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ],
    });
}

$('.product-slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.product-slider-nav'
});

$('.product-slider-for').slickLightbox();

$('.product-slider-nav').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    asNavFor: '.product-slider-for',
    dots: false,
    focusOnSelect: true
});

$(document).ready(function () {
    if ($('#faq-list > li > div > ul > li > .active').length) {
        $('#faq-list > li > .active').addClass('clickable');
    }
    if ($('#faq-list > li > div > ul > li > div > ul > li > .active').length) {
        $('#faq-list > li > .active').addClass('clickable');
        $('#faq-list > li > div > ul > li > .active').addClass('clickable');
    }
});

$(".js-slide-in").inViewport(function (px) {
    if ((px) && (getWidth() >= 768) && (!($(this).hasClass('animated')))) {
        $(this).addClass('animated slideInUp');
    }
});

function getWidth(){
    var width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
    return width;
}

function showSearchBar()
{
    if($('#searchDropdown').is(':visible'))
    {
        $('#searchDropdown').slideUp();
    }
    else $('#searchDropdown').slideDown();
}

$('#search-icon').click(function(){
    if(getWidth()>=768)
    {
        siteSearch(false);
    }
    else showSearchBar();
});












var vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', "".concat(vh, "px"));

window.addEventListener('resize', function () {
	var vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', "".concat(vh, "px"));
});

if ($("#distributor-filter-reset").length) {
    const resetButton = document.getElementById('distributor-filter-reset');
    resetButton.addEventListener('click', function() {
        const radiusContainer = document.querySelector('.distributor-radius-container');
        radiusContainer.classList.add('hidden');
    });
}

if ($("#distributor-filter-location-search").length) {
    var input = document.querySelector("#distributor-filter-location-search");
    input.addEventListener("keypress", function(event) {
        if (event.key === "Enter") {
            $("#distributor-filter-location-search-submit").click();
        }
    });
}




/*
Author: Jafar Akhondali
Release year: 2016
Title:	Light-Zoom JQuery plugin that use pure css to zoom on images, this enables you to zoom without loading bigger image and zoom even on gif images !
https://github.com/JafarAkhondali/lightzoom
*/
$.fn.lightzoom = function(options) {

    var settings = $.extend({
        zoomPower   : 3,
        glassSize   : 175,
    }, options);

    var halfSize= settings.glassSize /2;
    var quarterSize = settings.glassSize/4;

    var zoomPower = settings.zoomPower;

    $("body").append('<div id="glass"></div>');
    $('html > head').append($('<style> #glass{width: '+settings.glassSize+'px; height: '+settings.glassSize+'px;}</style>'));


    var faker;
    var obj=this;

    $("#glass").mousemove(function(event) {
        var obj=this.targ;
        event.target=obj;
        faker(event,obj);
    });

    this.mousemove(function(event) {
        faker(event,this);
    });
    faker=function(event,obj) {
        //console.log(obj);
        document.getElementById('glass').targ=obj;
        var mx = event.pageX;
        var my = event.pageY;
        var bounding = obj.getBoundingClientRect();
        var w = bounding.width;
        var h = bounding.height;
        var objOffset  = $(obj).offset();         
        var ol = objOffset.left;
        var ot = objOffset.top;
        if(mx > ol &&  mx < ol + w  && ot < my  &&  ot+h > my ) {
            offsetXfixer = ((mx-ol - w/2)/(w/2))*quarterSize;
            offsetYfixer = ((my-ot - h/2)/(h/2))*quarterSize;
            var cx = (((mx - ol + offsetXfixer ) / w)) * 100;
            var cy = (((my - ot + offsetYfixer ) / h)) * 100;
            my -= halfSize;
            mx -= halfSize;
            $("#glass").css({
                "top": (my),
                "left": (mx),
                "background-image" : " url('" + obj.src + "')",
                "background-size" : (w * zoomPower) + "px " + (h * zoomPower) + "px",
                "background-position": cx + "% " + cy + "%",
                "display" : "inline-block"
            });
            $("body").css("cursor","none");
        }else {
            $("#glass").css("display", "none");
            $("body").css("cursor","default");
        }
    };
    return this;
};

document.addEventListener("DOMContentLoaded", function(event) { 
    $('.zoom-effect').lightzoom({
        zoomPower   : 2,
        glassSize   : 300,
    });
});